import { useMutation } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';
import type {
  CreateCustomerOnboardingRequest,
  CreateCustomerOnboardingResponse,
} from '@metron/shared';

export function useCustomerOnboarding() {
  const apiClient = useApiClient();

  // Create onboarding entry mutation
  const createOnboardingMutation = useMutation({
    mutationFn: async (
      data: CreateCustomerOnboardingRequest,
    ): Promise<CreateCustomerOnboardingResponse> => {
      return await apiClient.post<CreateCustomerOnboardingResponse>(
        'customer-onboarding',
        data,
      );
    },
  });

  // Error handling - convert mutation error to string for backward compatibility
  const error = createOnboardingMutation.error
    ? (createOnboardingMutation.error instanceof Error
      ? createOnboardingMutation.error.message
      : 'Failed to create onboarding entry')
    : null;

  return {
    createOnboardingEntry: createOnboardingMutation.mutateAsync,
    isSubmitting: createOnboardingMutation.isPending,
    error,
  };
}
